export default __webpack_public_path__ + "static/media/DSC02952.9690440a.jpg";